import React from 'react'
import { RIDER_PORTAL_UI_MESSAGES } from 'src/constants/rider-portal'
import { ITripGroupRides } from 'src/types/trip-group-rides'

interface IPassengersAndPaymentMethodsProps {
  passengers: ITripGroupRides[]
}

const PassengersAndPaymentMethods = ({ passengers }: IPassengersAndPaymentMethodsProps) => {
  const {
    common: { passengers: passengersLabel },
    trips: { paymentMethods }
  } = RIDER_PORTAL_UI_MESSAGES
  return (
    <div>
      <h4 className='font-black3 font-medium rp-mb8 rp-my0 text-center text-md'>{`${passengersLabel} and ${paymentMethods}`}</h4>
      {passengers.map(({ fareType, riderType, totalRider }) => (
        <div className='rp-passenger-container rp-mb8' key={`${riderType}-${fareType}`}>
          <p className='font-grey8 rp-my0 text-md'>{riderType}</p>
          <p className='font-grey8 rp-my0 text-md'>{fareType}</p>
          <p className='font-grey8 rp-my0 text-md'>{totalRider}</p>
        </div>
      ))}
    </div>
  )
}

export default PassengersAndPaymentMethods



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/details/PassengersAndPaymentMethods.tsx